import * as leadformConstants from '../constants';

export default function getPanels(element){
  return [...element.querySelectorAll(leadformConstants.leadformClasses.panel)];
}
